import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-setupaddress',
  templateUrl: './setupaddress.component.html',
  styleUrls: ['./setupaddress.component.css']
})
export class SetupaddressComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  displayNext() {
    this.router.navigate(['/sales']);
  }
}
